export default "__VITE_ASSET__BTS24M_7__"